import React, {Component} from 'react';

import { connect } from 'react-redux'
import ChangePassword from './components/Login/ChangePassword'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class CreateAccountContainer extends Component {

  render() {
    return <ChangePassword create={true} {...this.props}/>
  }

}

export default connect((state) => ({ auth: state.auth }), mapDispatchToProps)(CreateAccountContainer)
